import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { PersonalizedRecommendationsFragment, Product } from 'src/types';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { ProductsSection } from 'src/components/products-section';
import { filterCategories } from '../../filter-categories';

type Props = {
  products?: Recommendations['products'];
  landingPage?: boolean;
};

type Recommendations = NonNullable<
  PersonalizedRecommendationsFragment['personalizedRecommendations']
>;

const PersonalizedProductRecommendations: React.FC<Props> = props => {
  const { products = { nodes: [] } } = props;
  const { t } = useAppContext();

  if (!(products && products.nodes) || !products.nodes.length) {
    return null;
  }

  const productsItems = filterCategories(products.nodes as Product[]);

  const trackHeaderClick = (data: { link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.PERSONALIZED_RECOMMENDATIONS_HEADER,
      nextPage: data.link,
    });
  };

  const trackProductCardClick = (data: { index: number; link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.PERSONALIZED_RECOMMENDATIONS_PRODUCT_CARD,
      nextPage: data.link,
      index: data.index,
    });
  };

  return (
    <ProductsSection
      products={productsItems}
      title={t('landing', 'personalized-products.title')}
      subTitle={t('landing', 'personalized-recommendations.subtitle')}
      linkPath="/personalization"
      linkTitle={t('account', 'menu.settings')}
      shouldLazyLoadImages
      dataTestType="product-recommendations"
      onHeaderLinkClick={trackHeaderClick}
      onProductCardClick={trackProductCardClick}
      landingPage={props.landingPage}
    />
  );
};

export default PersonalizedProductRecommendations;
